import { Platform } from "react-native";
import { CurvedTransition, LinearTransition } from "react-native-reanimated";

export const defaultLayoutTransition =
  Platform.OS === "web" ? LinearTransition : CurvedTransition;
